import React, { RefObject } from 'react';
import { Column } from 'react-table';
import { FormattedMessage } from 'react-intl';
import { IBindingCallback2, IBindingCallback1 } from '../../../../common/models/callback';
import { ReferenceType } from '../../../../common/enums/ReferenceType';
import { ISurveyQuestion } from '../../../../common/models/survey/ISurveyQuestion';
import styles from './styles.module.scss';
import ReferenceSelector from '../../components/ReferenceSelector';
import IconButton from '../../../../components/IconButton';
import Icon from '../../../../components/Icon';

export const getColumns = (containerRef: RefObject<HTMLElement>, actions: {
  onChangeReference: IBindingCallback2<string, ReferenceType[]>;
  onRemove: IBindingCallback1<ISurveyQuestion>;
}): Column[] => [
  {
    Header: () => <FormattedMessage id="question" defaultMessage="Question" />,
    id: 'question',
    Cell: ({ row }) => {
      const { question: { text, isRequired } } = row.original as ISurveyQuestion;
      return isRequired
        ? (
          <div>
            {text}
            &nbsp;
            <span className={styles.tableTip}>
              (
              <FormattedMessage id="required" defaultMessage="Required" />
              )
            </span>
          </div>
        )
        : <div className="overflow-wrap">{text}</div>;
    },
    width: 600
  },
  {
    Header: () => <FormattedMessage id="surveyBuilder.sendTo" defaultMessage="Send to" />,
    accessor: 'sendTo',
    Cell: ({ row }) => {
      const { question: { isRequired, id }, sendTo } = row.original as ISurveyQuestion;
      return (
        <ReferenceSelector
          containerRef={containerRef}
          disabled={isRequired}
          sendTo={sendTo as ReferenceType[]}
          onSelect={references => actions.onChangeReference(id, references)}
        />
      );
    },
    width: 250
  },
  {
    Header: () => <FormattedMessage id="remove" defaultMessage="Remove" />,
    id: 'remove',
    Cell: ({ row }) => {
      const surveyQuestion = row.original as ISurveyQuestion;
      return (
        <div className="table-center" style={{ maxWidth: '55px' }}>
          {surveyQuestion.question.isRequired
            ? <Icon icon="lock" className={styles.lockIcon} />
            : (
              <IconButton
                tooltip={{ id: 'surveyBuilder.remove', defaultMessage: 'Remove question' }}
                onClick={() => actions.onRemove(surveyQuestion)}
                icon={<Icon icon="minusCircle" />}
                variant="blue"
              />
            )}
        </div>
      );
    },
    width: 90
  }
];
